module.exports = __webpack_public_path__ + "static/img/bq.a217e580.svg";